<div class="background-signing">

</div>
<div class="container-fluid overlay">

  <div class="row">

    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 signLogo" *ngIf="signin">
      <img class="logo-align img-fluid" src="{{dataManager.loginlogo}}"/>
    </div>
  </div>
<!--  <div class="row image">-->
<!--&lt;!&ndash;    <img class="left-image" src="../../../assets/images/signin-left-image.png">&ndash;&gt;-->
<!--&lt;!&ndash;    <img class="right-image" src="../../../assets/images/signin-right-image.png">&ndash;&gt;-->
<!--  </div>-->
  <div class="row">
    <div *ngIf="signin" class="container-card col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 ipad_iphone">
      <ng-container *ngIf="topErrorMessage">
        <div class="row" *ngFor="let obj of keys1 ">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngFor="let value of obj ">
            <p class="col-sm-12 col-md-12 col-lg-12 col-xl-12 error" id="err">{{ value }}</p>
          </div>
        </div>
      </ng-container>
      <div class="row" *ngIf="!topErrorMessage">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 error mb-1"> {{ errorMsg }}</div>
      </div>
      <h3 class="text-center heading2">Welcome back!</h3>
      <div class="form-group row">
        <span class="error_sign col-2" id="username1">!</span>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 landscape_view">
          <div class="row">
            <label for="username" class="col-sm-12 col-md-12 col-lg-12 col-xl-12 l_label">Username:</label>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input class="form-control" type="text" name="username" (keydown)="onKeydown($event)" required
                     [(ngModel)]="username" id="username" placeholder="Username">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <span class="error_sign col-2" id="password1">!</span>
        <div class="col-sm-12 landscape_view">
          <div class="row">
            <div class="col-md-4">
              <label for="password" class="l_label">Password:</label>
            </div>
            <div class="col-md-8 text-right text-blue forgot-pass-m">
              <a (click)="redirectToForgotPassword()" class="pointer">Forgot your password?</a><br>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input type="password" class="form-control" (keydown)="onKeydown($event)" name="password" required
                     [(ngModel)]="password" id="password" placeholder="********"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row" *ngIf="tw0fa">
        <span class="error_sign col-2" id="tw0fa_error">!</span>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 landscape_view">
          <div class="row">
            <label for="tw0faCode" class="col-sm-12 col-md-12 col-lg-12 col-xl-12 l_label">2FA Code:</label>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input maxlength="6" class="form-control" type="text" name="tw0faCode" (keydown)="onKeydown($event)" required
                     [(ngModel)]="tw0faCode" id="tw0faCode" placeholder="2FA code">
            </div>
          </div>
          <div class="alert alert-success mt-3" role="alert">A verification code has been sent to your email. Please
            check your inbox to complete the two-factor authentication.
          </div>
        </div>
      </div>
      <div class="form-group row" *ngIf="app2fa">
        <span class="error_sign col-2" id="app2fa_error">!</span>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 landscape_view">
          <div class="row">
            <label for="app2faCode" class="col-sm-12 col-md-12 col-lg-12 col-xl-12 l_label">2FA Code:</label>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input maxlength="6" class="form-control" type="text" name="app2faCode" (keydown)="onKeydown($event)" required
                     [(ngModel)]="tw0faCode" id="app2faCode" placeholder="2FA code">
            </div>
          </div>
          <div class="alert alert-success mt-3" role="alert">Please enter 2FA code form your 2FA App.
          </div>
        </div>
      </div>

      <div class="form-group row pt-3 pb-2 continue-btn-m">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <button type="submit" [disabled]="loadFlag" class="bt_signin form form-control" (click)="signIn()">Continue<i
            *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i></button>
        </div>

      </div>

    </div>
  </div>
  <div class="row privacy-m">
    <div class="col-lg-5 col-md-5 col-sm-12 pt-3 container justify-content-center text-center">
      <div class="col bottom-align-m">
        <a href="https://www.payarc.com/privacy-policy" class="privacy" target="_blank">Privacy Policy</a><span
        class="p_line"> | </span><a href="https://www.payarc.com/company/terms-and-conditions" class="privacy"
                                    target="_blank">Terms &amp; Conditions</a>
      </div>

    </div>
  </div>

</div>
